import React, { useEffect, useState } from "react";
import serviceApi from "../../../services/serviceApi";
import environment from "../../../environments/environment";

interface PTMScheduleProps {
    entityId: string;
    onBack: () => void;
}

const PTMSchedule: React.FC<PTMScheduleProps> = ({
    entityId,
    onBack
}) => {
    const [ptm, setPtm] = useState<any | null>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        loadPTM();
    }, [entityId]);

    const loadPTM = async () => {
        if (!entityId) {
            setPtm(null);
            return;
        }

        try {
            setLoading(true);
            const res = await serviceApi.get<any>(
                `${environment.ptm}?entityId=${encodeURIComponent(entityId)}`
            );
            if (res?.status === "SUCCESS") {
                const list = res.dataList || [];
                const matched = list.find(
                    (item: any) =>
                        item.id === entityId ||
                        item.title === entityId
                );

                setPtm(matched || null);
            } else {
                setPtm(null);
            }
        } catch (err) {
            console.error("PTM API error:", err);
            setPtm(null);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="loading-overlay">
                <div className="loading-overlay__content">
                    <div className="spinner spinner--lg"></div>
                    <span className="loading-text">Loading PTM...</span>
                </div>
            </div>
        );
    }

    return (
        <div className="notification-page">
            <div
                style={{
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "35px 12px 15px 12px",
                    minHeight: "40px"
                }}
            >
                <button
                    onClick={onBack}
                    style={{
                        position: "absolute",
                        left: "12px",
                        border: "none",
                        background: "transparent",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: "var(--colorPrimaryDark)"
                    }}
                >
                    ← Back
                </button>

                <h2 className="title-text notification-heading">
                    {entityId}
                </h2>
            </div>
            {!ptm ? (
                <div
                    className="event-container"
                    style={{
                        textAlign: "center",
                        padding: "20px",
                        color: "#777"
                    }}
                >
                    Events not yet announced
                </div>
            ) : (
                <div className="event-container">
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <i className="fa-regular fa-calendar-check"
                            style={{ color: "var(--colorAccent)", fontSize: "14px" }} />
                        <span style={{
                            fontSize: "13px",
                            color: "#333",
                            fontWeight: "bold"
                        }}>
                            {ptm.date} | {ptm.time}
                        </span>
                    </div>
                    <h3 style={{
                        margin: "8px 0 4px 0",
                        color: "var(--colorPrimaryDark)"
                    }}>
                        {ptm.title}
                    </h3>
                    <hr style={{ borderTop: "1px solid #eee", margin: "12px 0" }} />
                    <p style={{ color: "#555" }}>
                        {ptm.description}
                    </p>
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-end"
                    }}>
                        <span style={{
                            fontSize: "10px",
                            fontWeight: "bold",
                            color: ptm.status === "CLOSED" ? "#f44336" : "#4caf50",
                            border: `1px solid ${ptm.status === "CLOSED" ? "#f44336" : "#4caf50"}`,
                            padding: "2px 6px",
                            borderRadius: "4px"
                        }}>
                            {ptm.status || "PLANNED"}
                        </span>
                        <div style={{ textAlign: "right" }}>
                            <div style={{ fontSize: "10px", color: "#999" }}>
                                IN-CHARGE
                            </div>
                            <div style={{ fontSize: "12px", fontWeight: "bold" }}>
                                {ptm.incharge}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PTMSchedule;